/** @format */

import React, { useState, useCallback, useEffect } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { toast } from "react-toastify";
import { Btn } from "../../../../AbstractElements";
import SvgIcon from "../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import {
  getAPIURL,
  getPPOMList,
  getVendorID,
} from "../../../../services/helper";
import { FaMinus, FaPlus } from "react-icons/fa";
import http from "../../../../services/http";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../ReduxToolkit/Reducers/AppReducer";
import { useNavigate } from "react-router-dom";
import AddonModalForm from "../../Addons/AddonForm";
import SelectCategory from "./SelectCategory";
// const addons = getPPOMList();

export default function AddProductDetails({
  activeCallBack,
  product,
  onFormChange,
}) {
  const [borderTab, setBorderTab] = useState(1);
  const activeBorder = useCallback((val) => setBorderTab(val), []);
  const { ppom_id, id: product_id, name } = product;
  const vendor_id = getVendorID();
  const api_url = getAPIURL();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Addons, setAddons] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState({
    productmeta_id: "new",
    productmeta_name: "",
    the_meta: {},
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const loadAddons = async () => {
      try {
        const { data: addonsResp } = await http.get(
          `${api_url}/addons?vendor_id=${vendor_id}`
        );

        const addons = addonsResp.map((addon) => {
          let parsedMeta = {};
          try {
            parsedMeta = JSON.parse(addon.the_meta || "{}");
          } catch (error) {
            console.error("Error parsing the_meta field", error);
          }

          return {
            ...addon,
            the_meta: parsedMeta,
          };
        });

        setAddons(addons);

        // const selected_addon = addons.find(
        //   (addon) => addon.productmeta_id === ppom_id
        // );

        // setSelectedAddon(selected_addon);
      } catch (error) {
        console.error(
          "Error fetching addons:",
          error.response ? error.response.data : error.message
        );
      }
    };

    loadAddons();
  }, []);

  // console.log(selectedAddon);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleAddonSave = async (row) => {
    try {
      dispatch(setLoading(true));
      toggleModal();

      row = { ...row, product_id, vendor_id };
      const { data } = await http.post(`${api_url}/addons`, row);
      const { addons, new_addon_id } = data;

      toast.success("Addons Saved");
      setAddons(addons);
      setSelectedAddon({
        productmeta_id: "new",
        productmeta_name: "",
        the_meta: {},
      });
      dispatch(setLoading(false));
      product.ppom_id = new_addon_id;
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error deleting addon:", error);
    }
  };

  const handleNextButton = () => {
    if (name !== "") {
      activeCallBack(2);
    } else {
      toast.error("Please fill out details before moving on to the next step");
    }
  };

  return (
    <div className="sidebar-body">
      <Form id="advance-tab">
        <Row className="g-2">
          {/* Product Name */}
          <Col xs={6}>
            <FormGroup>
              <Label>
                Product Name <span className="txt-danger">*</span>
              </Label>
              <Input
                type="text"
                name="name"
                value={product.name}
                onChange={(e) => onFormChange(e.target.name, e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <Label>
                SKU <span className="txt-danger">*</span>
              </Label>
              <Input
                type="text"
                name="sku"
                value={product.sku}
                onChange={(e) => onFormChange(e.target.name, e.target.value)}
              />
            </FormGroup>
          </Col>
          {/* Product Description */}
          <Col xs={12}>
            <FormGroup>
              <Label>Product Description</Label>
              <Input
                type="textarea"
                name="product_description"
                value={product.product_description}
                onChange={(e) => onFormChange(e.target.name, e.target.value)}
              />
            </FormGroup>
          </Col>
          {/* Price & Discount */}
          <Col xs={3}>
            <FormGroup>
              <Label>Cost</Label>
              <Input
                type="number"
                name="product_cost"
                value={product.product_cost}
                onChange={(e) => onFormChange(e.target.name, e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col xs={3}>
            <FormGroup>
              <Label>Price</Label>
              <Input
                type="number"
                name="regular_price"
                value={product.regular_price}
                onChange={(e) => onFormChange(e.target.name, e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col xs={3}>
            <FormGroup>
              <Label>Sale Price</Label>
              <Input
                type="number"
                name="sale_price"
                value={product.sale_price}
                onChange={(e) => onFormChange(e.target.name, e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col xs={3}>
            <FormGroup>
              <SelectCategory
                title="Categories"
                value={product.categories || []}
                onFormChange={onFormChange}
              />
            </FormGroup>
          </Col>
          {/* Stock Management (Checkbox & Quantity Inline) */}
          <Col xs={12}>
            <FormGroup className="d-flex align-items-center gap-3">
              <FormGroup check>
                <Input
                  id="manage_stock"
                  type="checkbox"
                  name="manage_stock"
                  checked={product.manage_stock || false}
                  onChange={(e) =>
                    onFormChange(e.target.name, e.target.checked)
                  }
                />
                <Label htmlFor="manage_stock" check>
                  Enable Stock
                </Label>
              </FormGroup>

              {product.manage_stock && (
                <Input
                  type="number"
                  name="stock_quantity"
                  placeholder="Stock Quantity"
                  value={product.stock_quantity}
                  onChange={(e) => onFormChange(e.target.name, e.target.value)}
                  style={{ width: "100px" }}
                />
              )}
            </FormGroup>
          </Col>
          {/* POS Restriction Checkbox */}
          <Col xs={12}>
            <FormGroup check>
              <Input
                id="cb-purchase_instore_only"
                type="checkbox"
                name="purchase_instore_only"
                checked={product?.purchase_instore_only === "yes"}
                onChange={(e) =>
                  onFormChange(e.target.name, e.target.checked ? "yes" : "no")
                }
              />
              <Label htmlFor="cb-purchase_instore_only" check>
                Sell in store only
              </Label>
            </FormGroup>
          </Col>
          {/* Addons Dropdown */}
          <Col xs={12}>
            <FormGroup>
              <Label>Select Addons</Label>

              <span
                style={{
                  color: "#66b1b1",
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
                onClick={toggleModal}
              >
                <FaPlus style={{ marginRight: "2px" }} />
                Add New
              </span>

              <div className="mt-2">
                <Row>
                  {Addons.map((addon, index) => (
                    <Col xs={4} key={addon.productmeta_id}>
                      <FormGroup check>
                        <Input
                          type="checkbox"
                          name="ppom_id"
                          id={`cb-ppom_id_${addon.productmeta_id}`}
                          value={addon.productmeta_id}
                          checked={
                            Array.isArray(product?.ppom_id) &&
                            product.ppom_id.includes(addon.productmeta_id)
                          }
                          onChange={(e) =>
                            onFormChange(
                              "ppom_id",
                              addon.productmeta_id,
                              e.target.checked
                            )
                          }
                        />
                        <Label
                          htmlFor={`cb-ppom_id_${addon.productmeta_id}`}
                          check
                        >
                          {addon.productmeta_name}
                        </Label>
                      </FormGroup>
                    </Col>
                  ))}
                </Row>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </Form>

      {/* Next Button */}
      <div className="product-buttons">
        {/* <Btn className="m-2" color="danger" onClick={toggleModal}>
          <div className="d-flex text-white align-items-center gap-sm-2 gap-2">
            Cancel
          </div>
        </Btn> */}

        <Btn color="transparent" onClick={handleNextButton}>
          <div className="d-flex align-items-center gap-sm-2 gap-1">
            <SvgIcon iconId="front-arrow" /> Next
          </div>
        </Btn>
      </div>

      <AddonModalForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        originalRow={selectedAddon}
        onSave={handleAddonSave}
      />
    </div>
  );
}
